import { redirect } from '@tanstack/react-router'

import type { RouterContext } from '@/routes/layouts/root'
import { resolveBrokerCode } from '@/screens/brokers/ByBrokerRedirect.loader'

/**
 * The `/brokers/reviews` loader — the Reviews row and tab with no house in
 * view (pages revamp, 2026-10-27): the house By Broker would open, the
 * member's last-used or the market's busiest, on its own reviews page. See
 * `ByBrokerRedirect.loader.ts` for how that house is chosen and checked, and
 * `ByStockRedirect.loader.ts` for the "always throws" and "one fallback,
 * never a loop" notes; all apply here unchanged.
 */
export async function loadReviewsRedirect({
  context: { queryClient },
}: {
  context: RouterContext
}): Promise<never> {
  const code = await resolveBrokerCode(queryClient)
  // eslint-disable-next-line @typescript-eslint/only-throw-error
  throw redirect({ to: '/brokers/$code/reviews', params: { code }, replace: true })
}
